
import { Component, OnInit } from '@angular/core';

import "survey-core/survey.i18n.js";
import "survey-creator-core/survey-creator-core.i18n.js";

import { surveyLocalization } from 'survey-core';

import { ComponentCollection } from "survey-core";
import { Serializer } from "survey-core";
import {  MenuItem, MessageService, SelectItem } from 'primeng/api';
import { localization } from "survey-creator-core";
import { ApiService } from 'src/app/_services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/_services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SurveyCreatorModel } from "survey-creator-core";

import { setLicenseKey } from "survey-core";



@Component({
  selector: 'app-checkl-model-edit',
  templateUrl: './checkl-model-edit.component.html',
  styleUrls: ['./checkl-model-edit.component.css'],
  providers: [ MessageService]
})
export class ChecklModelEditComponent implements OnInit {
  surveyCreatorModel: SurveyCreatorModel=new SurveyCreatorModel({});
  isLoading=true;
  creator:any;

  checkl={
    name:'',
    status:'BOZZA',
    rev:1,
    ambito:'',
    roles:[],
    json: '{ "pages" : [' +
    '{ "name":"page1"' +
    ' }]}'
  };
  
  statusList:SelectItem[] = [];  
  ambitoList:SelectItem[] = [];  
  surveytitle='';
  action='';  
  id:number;
  roleslist:any[]=[];
  breadcrumbs: MenuItem[];
  selectedRoles:any[]=[];

  errors: {
    DescrizioneError: boolean,

  };
  constructor(
    private apiService: ApiService,
    private messageService: MessageService,
    private translate: TranslateService,
    private globalService: GlobalService,
    private route: ActivatedRoute,
    private router: Router,
  ) { 
    setLicenseKey("Y2UyZmM4MzktN2Y3ZS00MGY3LWEwOGYtMzM1YjE3MTkwMzkwOzE9MjAyNC0wOC0wNw==" );
  }


  ngOnInit(): void {

    this.initErrors();  
  //  this.loadsurvey('');
    this.statusList.push({value:'DRAFT',label:'DRAFT'});
    this.statusList.push({value:'PUBBLICATO',label:'PUBBLICATO'});
    this.statusList.push({value:'CHIUSO',label:'CHIUSO'});
    
    this.ambitoList.push({value:'STRUTTURE',label:'STRUTTURE'});
    this.ambitoList.push({value:'UFFICI',label:'UFFICI'});
    this.ambitoList.push({value:'GENERICO',label:'GENERICO'});

    const params: any = {PageSize : 10000};
 
    this.action=this.route.snapshot.paramMap.get('action');
    this.id=null;
    if (!this.route.snapshot.paramMap.get('id')) {
        const params: any = {PageSize : 10000};
        this.loadsurvey(this.checkl['json']);
        this.isLoading=false;
    } else {
      
      this.id=parseInt(this.route.snapshot.paramMap.get('id'));
      this.apiService.get('checklists/listall',params).subscribe(data => {
        for (const g of data.Result) {
          if(g['id']==this.id){
            this.checkl=g;
            this.selectedRoles=g.roles;
            if(this.checkl['json']){
              this.loadsurvey(this.checkl['json']);
              this.isLoading=false;
            }
          }
        }
      });
  
    }

 
    this.apiService.get('hp/roleslistall',{}).subscribe(data => {
      this.roleslist=data.Result;
    });
    
  
  }
 
  loadsurvey(jsonsurvey){
    
    surveyLocalization.supportedLocales = ["it"];
    Serializer.addProperty("question", {
      name: "question_weight",
      type: "number",
      default: 1,
      displayName: "Peso",
      category: "general",
      isRequired: true,
      visibleIndex: 0,
      onSetValue: (survey, value) => {
          // ...
          // You can perform required checks or modify the `value` here
          // ...
          // Set the `value`
          survey.setPropertyValue("RequiredQuestion", value);
          // You can perform required actions after the `value` is set
          // ...
      }
    });
  

    localization.currentLocale = "it";
    
    

    const creatorOptions = {
      showLogicTab: false,
      showJSONEditorTab:false,
      showThemeTab: true
    };
    this.creator = new SurveyCreatorModel(creatorOptions);
    this.creator.localization='it';
    if(jsonsurvey!=''){
      this.creator.text=jsonsurvey;

    }

    this.surveyCreatorModel =this.creator;
    


  }
  
  private initErrors() {
    this.errors = {} as any;
  
    
 
  }
 

  private validate() : boolean {
    let isValid : boolean = true;
   
      if (!this.creator.JSON.title) {
        this.addSingle('error', 'Errore', 'Campo nome obbligatorio');
         isValid = false;
        
      }

    return isValid;
  }


  public save() {

      this.initErrors();
      if (!this.validate()) return;
      if(this.id){
        this.checkl['id']=this.id;
        if(this.action=='newrev'){
          this.checkl['rev']=1; 
        }
      } else {
        this.checkl['rev']=1;
      }

     
      if(this.creator.JSON.title[this.creator.JSON.locale]){
        this.checkl['name']=this.creator.JSON.title[this.creator.JSON.locale];
      } else {
        this.checkl['name']=this.creator.JSON.title;
      }
      this.checkl['json']=JSON.stringify( this.creator.JSON );
      this.checkl.roles=this.selectedRoles;
      this.apiService.updateChecklModel(this.checkl).subscribe(data => {
        this.addSingle('success', 'Successo', 'Modello salvato');
        this.router.navigateByUrl('/dashboard/checklists/checkl-models');
      });
    

  }
 

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

  


}
